import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, resolveMediaUrl } from '../lib/api';
import { useAuth } from '../context/AuthContext';
import { useLanguage } from '../context/LanguageContext';

export default function EditProfile() {
  const { user, refresh } = useAuth();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [form, setForm] = useState({
    name: user?.name || '',
    surname: user?.surname || '',
    gender: user?.gender || '',
    age: user?.age || '',
    height: user?.height || '',
    weight: user?.weight || '',
    userImage: null,
  });
  const [error, setError] = useState('');

  const handleChange = (event) => {
    const { name, value, files, type } = event.target;
    if (type === 'file') {
      setForm((prev) => ({ ...prev, userImage: files[0] }));
      return;
    }
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    try {
      const formData = new FormData();
      Object.entries(form).forEach(([key, value]) => {
        if (value) {
          formData.append(key, value);
        }
      });
      await api.post('/update-profile', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      await refresh();
      navigate('/profil');
    } catch (err) {
      setError(err?.response?.data?.message || t('auth.updateError'));
    }
  };

  return (
    <div className="card">
      <h2 className="section-title">{t('profile.edit')}</h2>
      <p className="section-subtitle">{t('profile.updateDesc')}</p>
      <div style={{ marginTop: 16 }}>
        {user?.userImage ? (
          <img
            src={resolveMediaUrl(user.userImage)}
            alt="profile"
            style={{ width: 96, height: 96, borderRadius: 24 }}
          />
        ) : null}
      </div>
      <form onSubmit={handleSubmit} className="grid two-col" style={{ marginTop: 24 }}>
        <div>
          <label className="muted">{t('auth.name')}</label>
          <input className="input" name="name" value={form.name} onChange={handleChange} />
        </div>
        <div>
          <label className="muted">{t('auth.surname')}</label>
          <input className="input" name="surname" value={form.surname} onChange={handleChange} />
        </div>
        <div>
          <label className="muted">{t('auth.gender')}</label>
          <input className="input" name="gender" value={form.gender} onChange={handleChange} />
        </div>
        <div>
          <label className="muted">{t('auth.age')}</label>
          <input className="input" name="age" value={form.age} onChange={handleChange} />
        </div>
        <div>
          <label className="muted">{t('auth.height')}</label>
          <input className="input" name="height" value={form.height} onChange={handleChange} />
        </div>
        <div>
          <label className="muted">{t('auth.weight')}</label>
          <input className="input" name="weight" value={form.weight} onChange={handleChange} />
        </div>
        <div style={{ gridColumn: '1 / -1' }}>
          <label className="muted">{t('auth.photo')}</label>
          <input className="input" type="file" name="userImage" onChange={handleChange} />
        </div>
        {error ? <p style={{ color: 'var(--danger)', gridColumn: '1 / -1' }}>{error}</p> : null}
        <div style={{ gridColumn: '1 / -1' }}>
          <button className="btn btn-primary" type="submit">
            {t('actions.save')}
          </button>
        </div>
      </form>
    </div>
  );
}
